import styled from 'styled-components';

// NOTE: left position + hidden is to hide the div from user
//       just want to load font without displaying anything
const PixeledLoader = styled.div`
  color: black;
  position: absolute;
  width: 1px;
  font-family: 'Pixeled';
  visibility: hidden;
  left: -9999px;
`;

const ComfortaaLoader = styled.div`
  color: black;
  position: absolute;
  width: 1px;
  font-family: 'Comfortaa-Regular';
  visibility: hidden;
  left: -9999px;
`;

export { PixeledLoader, ComfortaaLoader };
